export default "__VITE_ASSET__brF1AZTp__"